import { StateCreator } from 'zustand';
import { BoundStoreState, useBoundStore } from './index';

export interface DocumentReviewSliceState {
	reviewModeData: {
		sourceSlug: string;
		targetSlug: string;
		sourceIsDraft: boolean;
		targetIsDraft: boolean;
		isInitialized: boolean;
		needsRefresh: boolean;
	};
	comparisonPanelState: {
		isOpen: boolean;
		changesCount: number;
	};
}

export const createDocumentReviewSlice: StateCreator<
		BoundStoreState,
		[],
		[],
		DocumentReviewSliceState
> = () => ({
  reviewModeData: {
    sourceSlug: '',
    targetSlug: '',
    sourceIsDraft: false,
    targetIsDraft: true,
    isInitialized: false,
    needsRefresh: false,
  },
  comparisonPanelState: {
    isOpen: false,
    changesCount: 0,
  },
});

export const setReviewModeData = (data: Partial<DocumentReviewSliceState['reviewModeData']>) => {
  useBoundStore.setState((state) => ({
    reviewModeData: {
      ...state.reviewModeData,
      ...data,
    },
  }));
};

export const setComparisonPanelState = (data: Partial<DocumentReviewSliceState['comparisonPanelState']>) => {
  useBoundStore.setState((state) => ({
    comparisonPanelState: {
      ...state.comparisonPanelState,
      ...data,
    },
  }));
};

export const resetReviewMode = () => {
  useBoundStore.setState({
    reviewModeData: {
      sourceSlug: '',
      targetSlug: '',
      sourceIsDraft: false,
      targetIsDraft: true,
      isInitialized: false,
      needsRefresh: false,
    },
    comparisonPanelState: {
      isOpen: false,
      changesCount: 0,
    },
    historyData: {
      new_blocks: { title: [], text_content: [], json_content: [] },
      deleted_blocks: { title: [], text_content: [], json_content: [] },
      modified_blocks: { title: [], text_content: [], json_content: [] },

      new_articles: { title: [], text_content: [], json_content: [] },
      deleted_articles: { title: [], text_content: [], json_content: [] },
      modified_articles: { title: [], text_content: [], json_content: [] },

      new_sections: { title: [], text_content: [], json_content: [] },
      deleted_sections: { title: [], text_content: [], json_content: [] },
      modified_sections: { title: [], text_content: [], json_content: [] },
    },
  });
};

export const markReviewModeForRefresh = () => {
  useBoundStore.setState((state) => ({
    reviewModeData: {
      ...state.reviewModeData,
      needsRefresh: true,
    },
  }));
};

